module.exports = __webpack_public_path__ + "3301bba0e0857a79e2776f56d0941949.svg";